import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import { useMenuStore } from '../../../zustand/store/useMenuStore';
import useModalStore from '../../../zustand/store/useModalStore';

import '../../../css/modal.css'
import { FaceDalgu16, FaceSalgu16 } from '../../../images/icons/icons_component'

/**
 * @ToastModal
 -- toast modal component는 Main component에 이미 지정되어 있어 따로 import해줄 필요없음
 -- 전역 변수로 지정한 toastModalOpen 함수 import후 사용하고 싶은 함수 안에 메시지와 함께 작성
  <sample>
    import { useModalOpen } from '../../../hooks/useModalOpen';

    const {toastModalOpen} = useModalOpen();
    const useripinReset = async (useridno) => {
        try {
            if(window.confirm('초기화 하시겠습니까?')) {
                await axios.post(apiCall, { useridno: useridno });
                toastModalOpen('정상적으로 초기화 되었습니다.');
            }
        } catch (error) {
            console.error('오류 발생:', error);
        }
    }
 */

const ToastModal = () => {

    // Dynamic Style Hook
    const { fontColor, toastBorderColor } = useDynamicStyle();

    const clickedCategory = useMenuStore((state) => state.clickedCategory);
    const toastIcon = clickedCategory === 21 ? <FaceSalgu16/> : <FaceDalgu16/>;

    const text = useModalStore((state) => state.text);

    return (
        <div className='toast_modal_wrapper' style={{top: '1%'}}>
            <div className={`toast_modal_text ${fontColor} ${toastBorderColor}`}>
                {toastIcon}{text}
            </div>
        </div>
    )
}

export default ToastModal